import { CalendarEventDetails, CalendarEventRef } from '@griply/types';

export const externalCalendarEventQueryKey = 'external-calendar-event';

// A callable, not a Firestore subscription — the TTL is the server-side validity of the details.
export const EXTERNAL_CALENDAR_EVENT_TTL_MS = 60 * 1000;

export type FetchExternalCalendarEvent = (
  eventRef: CalendarEventRef,
) => Promise<CalendarEventDetails | null>;

// one config for both apps' detail query + fetch-on-demand hooks — a drifted key shape would silently break their cache sharing
export const getExternalCalendarEventQueryConfig = (
  eventRef: CalendarEventRef | null,
  fetchEvent: FetchExternalCalendarEvent,
) => ({
  queryKey: [
    externalCalendarEventQueryKey,
    eventRef?.connectionId,
    eventRef?.calendarId,
    eventRef?.eventId,
  ],
  queryFn: async (): Promise<CalendarEventDetails | null> =>
    fetchEvent(eventRef!),
  staleTime: EXTERNAL_CALENDAR_EVENT_TTL_MS,
  gcTime: EXTERNAL_CALENDAR_EVENT_TTL_MS,
});
